import { GraduationCap } from "lucide-react";

export const TrainingBanner = () => {
  if (process.env.REACT_APP_TRAINING_MODE !== "true") return null;
  return (
    <div
      data-testid="training-banner"
      className="flex items-center justify-center gap-2 bg-amber-400 px-3 py-1.5 text-center text-[11px] font-bold uppercase tracking-[0.22em] text-[#232826]"
    >
      <GraduationCap size={14} strokeWidth={2.2} />
      Training Environment — practice only, not live data
    </div>
  );
};
